export default [
    {
        path: '/client',
        name: 'ClientDashboard',
        component: () => import(/* webpackChunkName: "about" */ '../../views/client/ClientViewDashboard.vue')
    },
]